<template>
  <div class="form-area">

    <!-- 前頁面為第一位用戶填寫 -->
    <div class="form-title" v-if="currentOperateName==='liveEmployment'">
      請填寫閣下的個人資料</br>
      Please fill in your personal particulars
    </div>
    <!-- 前頁面為第二位用戶填寫 -->
    <div v-if="currentOperateName==='liveEmployment2'" class="form-title">
      請填寫第⼆位申請⼈的住屋、生活及工作資料<br>Please fill in second applicant's housing, living, and employment Information
    </div>
    <!-----------------個人住屋資料 --------------->
    <div>
      <div class="form-desc">
        個人住屋資料</br>
        Housing information
      </div>
      <el-form :model="hleFormData" :rules="hleFormDataRules" ref="hleFormData">
        <el-row :gutter="10" class="form-row">
          <el-col :span="4">
            <div class="form-label">住址 *</br> Residential address</div>
          </el-col>
          <el-col :span="16">
            <el-row :gutter="3">
              <el-col :span="10">
                <el-form-item prop="islands">
                  <el-select class="form-select" @change="handleIslandsChange" v-model="hleFormData.islands"
                    placeholder="香港島 HK">
                    <el-option v-for="(item,index) in islands" :key="'islands'+index" :label="item.label" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-form-item prop="areas">
                  <el-select class="form-select" v-model="hleFormData.areas" placeholder="中西區 Central and Western">
                    <el-option v-for="(item,index) in areas" :key="'areas'+index" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>


            <el-row class="address-row">          
              <el-col :span="24">
                <el-form-item prop="detailAddress">
                  <el-input placeholder="詳細地址 Detail Address" v-model="hleFormData.detailAddress"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>


        <el-row :gutter="10" class="form-row">
          <el-col :span="4">
            <div class="form-label">家庭住户人數 *</br> Number of domestic households</div>
          </el-col>
          <el-col :span="8">
            <div class="form-input">
              <el-form-item prop="householdsNum">
                <el-input placeholder="ex:2" v-model="hleFormData.householdsNum"  @input="(v)=>(hleFormData.householdsNum=v.replace(/[^\d]/g,''))"></el-input>
              </el-form-item>
            </div>
            <div class="form-tip-mid">
              包括申請者本人including the applicant
            </div>
          </el-col>
          <el-col :span="12">
            <div class="unit-desc">人 Person</div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="form-row">
          <el-col :span="4">
            <div class="form-label">實用面積 *</br> Saleable area</div>
          </el-col>
          <el-col :span="8">
            <div class="form-input">
              <el-form-item prop="saleableArea">
                <el-input placeholder="ex:250" @input="(v)=>(hleFormData.saleableArea=v.replace(/[^0-9.]/g,''))"  v-model="hleFormData.saleableArea"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="unit-desc">平方呎 Sq. ft</div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="form-row">
          <el-col :span="4">
            <div class="form-label">住所類型*<br>Type of Residence </div>
          </el-col>
          <el-col :span="20">
            <div class="form-input">
              <el-form-item prop="residenceType">
                <el-radio-group v-model="hleFormData.residenceType">
                  <el-radio v-for="(item,index) in residenceTypes" :key="'rt'+index" :label="item.value">
                    <div class="input-container" v-if="index==residenceTypes.length-1">
                      <div class="text">其他<br> Others</div>
                      <textarea ref="textarea" maxlength="100" v-model="hleFormData.otherResidenceType"
                        placeholder="請輸入其他住所類型" class="textarea"></textarea>
                    </div>
                    <div class="living-radio" v-else v-html="item.label" />
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <!-----------------申請人個人生活及工作資料 --------------->
        <div class="form-desc">
          申請人個人生活及工作資料</br>
          Living and employment information
        </div>

        <el-row :gutter="10" class="form-row" v-for="(field,index) in livingFormFields" :key="'f'+index">
          <el-col :span="6">
            <div class="form-label" v-html="field.label"></div>
          </el-col>
          <el-col :span="12">
            <div class="form-input">
              <el-form-item :prop="field.key">
                <el-select v-if="field.type=='select'" class="form-select" v-model="hleFormData[field.key]"
                  :placeholder="field.placeholder" :clearable="true">
                  <el-option v-for="dict in dict.type[field.key]" :key="dict.value" :label="dict.label"
                    :value="dict.value"></el-option>
                </el-select>
                <el-input v-if="field.type=='textarea'" maxlength="500" type="textarea" :rows="5" resize="none"
                  placeholder="" v-model="hleFormData[field.key]" />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6" v-if="field.desc">
            <div class="form-tip-mid" v-html="field.desc" />
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 前頁面為第一位用戶填寫 -->
    <div class="btn-box" v-if="currentOperateName==='liveEmployment'">
      <el-button class="next-btn" type="warning" round @click="saveAndNextSetp(1)">儲存並繼續 Save & Next</el-button>
    </div>
    <!-- 前頁面為第二位用戶填寫 -->
    <div class="btn-box" v-if="currentOperateName==='liveEmployment2'">
      <el-row>
        <el-col :span="12">
          <el-button type="warning" class="two-btn" round @click="previousSetp">上一步 Back</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="warning" class="two-btn" round @click="saveAndNextSetp(2)">儲存並繼續 Save & Next</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import {
    filterFormRulesData,
    filterFormFieldsData
  } from "@/utils/json/utils";
  import {
    getDicts,
    liveEmploymentForm
  } from "@/assets/js/api";
  export default {
    dicts: ["education"],
    watch: {
      "hleFormData.residenceType"(n, o) {
        if (n != "other") {
          this.hleFormData.otherResidenceType = "";
        }
      },
    },
    data() {
      return {
        //判斷是單人申請還是雙人
        isSingle: this.Session.get("formId") === 1,
        //判斷當前是第一人還是第二人
        currentOperateName: this.$store.getters.querySetepInfo.currentOperateName,
        //判斷該流程是首次申請還是繼續申請
        setepName: this.$store.getters.querySetepInfo.currentStepName,
        hleFormData: {}, //住屋、生活及工作资料表单
        livingFormFields: filterFormFieldsData("livingFormFields"),
        residenceTypes: [],
        hleFormDataRules: filterFormRulesData("hleFormDataRules"),
        areas: [],
        islands: filterFormFieldsData("islands"),
        areas: filterFormFieldsData("HKI"),
        value: "",
      };
    },
    created() {
      this.initFormData();
      //加载字典
      this.loadDictDatas("residence_types");
    },
    methods: {
      initFormData() {
        if ("liveEmployment" === this.currentOperateName) {
          this.loadFirstApplyerInfo();
        }
        if ("liveEmployment2" === this.currentOperateName) {
          this.loadSecondApplyerInfo();
        }
      },
      loadFirstApplyerInfo() {
        this.hleFormData = this.Session.get("hleFormData") || {};
      },
      /**
       * 加载字典
       */
      loadDictDatas(key) {
        getDicts(key).then((res) => {
          this.residenceTypes = res;
        });
      },
      //第二個用戶總是load緩存
      loadSecondApplyerInfo() {
        this.hleFormData = this.Session.get("hleFormData2") || {};
      },
      //進二人申請時才會觸發，點擊後加載第一位申請者信息
      previousSetp() {
        this.Session.set("hleFormData2", this.hleFormData);
        this.$store.dispatch("PREVIOUS_SETP", {
          changeStep: false,
          operateName: "liveEmployment",
        });
        this.loadFirstApplyerInfo();
      },
      //计算人均面积
      computeAvg() {
        //计算人均面积
        let obj = this.hleFormData;
        var avgArea = (obj.saleableArea / obj.householdsNum).toFixed(2)
        this.hleFormData.avgArea = avgArea
      },
      //保存並下一步操作
      saveAndNextSetp(k) {
        if (1 === k) {
          //第一人页面
          this.computeAvg();
          this.Session.set("hleFormData", this.hleFormData);
          //判斷是一人還是二人申請
          if (this.isSingle) {
            //直接提交
            this.submit();
          } else {
            //二人申請先校驗，然後跳轉到第二個人填寫資料界面
            this.$refs.hleFormData.validate((valid) => {
              if (valid) {
                this.$store.dispatch("NEXT_STEP", {
                  changeStep: false,
                  operateName: "liveEmployment2",
                });
                this.loadSecondApplyerInfo();
              }
            });
          }
        }
        if (2 === k) {
          //第二人页面
          //直接提交數據並進入下一個步驟，注意這裡要把第二個表單換入session一起提交
          this.computeAvg();
          this.Session.set("hleFormData2", this.hleFormData);
          this.submit();
        }
      },
      submit() {
        //驗證表單
        this.$refs.hleFormData.validate((valid) => {
          if (valid) {
            //提交接口
            let params = {
              liveEmploymentInfo: JSON.stringify({
                hleFormData: this.Session.get("hleFormData"),
                hleFormData2: this.Session.get("hleFormData2"),
              }),
            };
            liveEmploymentForm(params).then((res) => {
              //跳转至申明
              this.$store.dispatch("NEXT_STEP", {
                changeStep: true,
                operateName: "declaration",
              });
            });
          } else {
            console.log("error submit!!");
            this.validFail();
            return false;
          }
        });
      },
      // 校验未通过时的处理
      validFail() {
        // 定位到错误信息位置
        setTimeout(() => {
          let isError = document.getElementsByClassName("is-error");
          isError[0].querySelector("input").focus();
        }, 100);
        this.$message.warning("請填寫紅色必填欄目");
      },
      /**
       * 地區選擇聯動
       */
      handleIslandsChange(item) {
        this.areas = filterFormFieldsData(item.value);
        delete this.hleFormData.areas;
      },
    },
  };

</script>

<style>
  /* 默认情况下，el-radio-button 在 el-radio-group 内是块级元素，会竖向排列。  
   但如果你需要覆盖默认样式或确保它们始终竖向排列，可以添加以下 CSS。 */
  .el-radio-group .el-radio {
    display: block;
    margin-bottom: 10px;
    /* 可选：增加间距 */
  }

  .el-radio__label {
    width: 100%;
  }

  .text {
    float: left;
    /*background-color: #ff1d5e;*/
  }

  .input {
    padding: 0 0;
    margin-left: 10px;
    float: left;
    width: calc(100% - 4em);
  }

  .textarea {
    padding: 0;
    position: relative;
    left: 30px;
    display: inline-block;
    width: 50%;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    resize: none;
    border-radius: 0;
    border: none;
    color: #6b7280;
    border-bottom: 1px solid #6b7280;
    font-family: "IBM Plex Sans";
  }

  .textarea:focus {
    outline: none;
  }

</style>



// WEBPACK FOOTER //
// src/view/apply/child/liveEmployment.vue